import { render } from "./switch-control.vue?vue&type=template&id=6e4817e6&scoped=true&ts=true"
import script from "./switch-control.vue?vue&type=script&lang=ts"
export * from "./switch-control.vue?vue&type=script&lang=ts"

import "./switch-control.vue?vue&type=style&index=0&id=6e4817e6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4817e6"]])

export default __exports__